/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'checkmarks/not-completed': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M13.66 2.34c-3.122-3.12-8.198-3.12-11.32 0-3.12 3.122-3.12 8.2 0 11.32A7.98 7.98 0 008 16a7.98 7.98 0 005.66-2.34c3.12-3.12 3.12-8.198 0-11.32zM11.3 10.36a.666.666 0 11-.942.943L8 8.943l-2.357 2.358a.667.667 0 01-.943-.943L7.057 8 4.699 5.642a.666.666 0 11.943-.943L8 7.057l2.358-2.358a.666.666 0 11.943.943L8.943 8l2.358 2.359z" _fill="#000" fill-rule="evenodd"/>'
  }
})
